import HomeView from './views/HomeView.vue'

import FormCancelledView from './views/FormCancelledView.vue'

export default [
  { path: '/', name: 'home', component: HomeView, meta: { title: 'Home', layout: 'fluid' } },

  { path: '/form-cancelled', name: 'form-cancelled', navHide: true, component: FormCancelledView, meta: { title: 'Form Cancelled', layout: 'narrow' } },
]



// WEBPACK FOOTER //
// ./src/home/routes.js